// Kept out of index.tsx so that file only exports the component
// (react-refresh/only-export-components).
export const SCHEDULE_DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export type ScheduleDay = (typeof SCHEDULE_DAYS)[number];
